import { useRouter } from "next/router";
import { Box, Text, Flex } from "@chakra-ui/react";

import IsDoctor from "../permission/isDoctor";
import {
  Button as ButtonComponent,
  FreeDeliveryOffer,
} from "../../../src/components/common";

import { FLAT_SHIPPING_RATE } from "../../../src/constants";

export default function Index({ cart }) {
  const router = useRouter();

  const subTotalWithoutDiscount = cart.reduce(
    (a, b) => a + b.quantity * parseFloat(b.price),
    0
  );
  const subTotalDoctorPrice = cart.reduce(
    (a, b) => a + b.quantity * parseFloat(b.doctorPrice),
    0
  );

  const subTotal = IsDoctor() ? subTotalDoctorPrice : subTotalWithoutDiscount;

  const shippingCost =
    subTotal >= 1000 ? parseFloat(0) : parseFloat(FLAT_SHIPPING_RATE);

  const totalPrice = subTotal + shippingCost;

  return (
    <Flex
      px="20.5px"
      height="100%"
      borderWidth={1}
      borderRadius={4}
      flexDirection="column"
      ml={{ base: "0px", xl: "30px" }}
      width={{ base: "100%", xl: "25%" }}
      mt={{ base: "0px", md: "30px", xl: "0px" }}
    >
      <Text
        py="10.5px"
        color="maroon"
        borderBottomWidth={1}
        variant="cartBoldMaroon"
      >
        Cart Total
      </Text>
      <Box borderBottomWidth={1}>
        <Flex pt="20.5px" width="100%" justifyContent="space-between">
          <Text variant="cartRegular">Subtotal</Text>
          <Text variant="cartRegular">₹{subTotal.toFixed(2)}</Text>
        </Flex>
        <Flex py="20.5px" width="100%" justifyContent="space-between">
          <Text variant="cartRegular">Shipping</Text>
          <Text variant="cartRegular">₹{shippingCost.toFixed(2)}</Text>
        </Flex>
      </Box>
      <Flex py="20.5px" width="100%" justifyContent="space-between">
        <Text variant="cartBold">Total</Text>
        <Text variant="cartBold">₹{totalPrice.toFixed(2)}</Text>
      </Flex>
      <Flex pb="20.5px" width="100%" overflow={"hidden"} flexDirection={"column"} justifyContent="center" alignItems={"center"}>
        <ButtonComponent
          width={300}
          backgroundColor="maroon"
          title="Proceed to checkout"
          handleClick={() => router.push("/checkout")}
        />
        <FreeDeliveryOffer />
      </Flex>
    </Flex>
  );
}
